angular.module('leanlaw').directive('llChargeTableDirective', [function () {
  return {
    restrict: 'AE',
    template: require("./views/chargeTable.html"),
    scope: {
      me: '=',
      sort: '=',
      wip: '=',
      sort2: '=',
      charges: '=',
      chargeEdit: "=?",
      chargeStatusUpdate: "=?",
      completedOrUpcoming: "=",
      billedSelected: "=?"
    },
    controller: ['$scope', 'lists', function ($scope, lists) {
      $scope.lists = lists;
    }]
  };
}]);